import { useAuthHeaders } from "@src/frontend/hooks/useAuthHeaders";
import { useMessageHandler } from "@src/frontend/hooks/useMessageHandler";
import type { Res } from "@src/frontend/utils/types";
import { useRequest } from "ahooks";
import { useRestAPI } from "@src/frontend/hooks/useRestAPI";
import type { UserScriptModel } from "@src/generated/prisma/models";
import { useListDataScore } from "@src/frontend/stores/listDataScore";

const API = '/api/scripts';
export const useScriptsAPI = () => {
  const { handleMessage } = useMessageHandler();
  const { getAuthHeader } = useAuthHeaders();
  const { listReq, createReq, delReq, updateReq } = useRestAPI<UserScriptModel>(API);
  const listPubReq = useRequest<Res<UserScriptModel[]> | null, []>(async () => {
    const headers = await getAuthHeader();
    if (!headers) return null;
    return fetch(`${API}?publish=true`, { headers }).then(res => res.json())
      .then((data: Res<UserScriptModel[]>) => {
        handleMessage(data);
        useListDataScore.getState().setMap(`${API}?publish=true`, data.data ?? []);
        return data;
      }).catch(e => {
        handleMessage(e);
        return null;
      });
  }, {});
  return {
    listPubReq, listReq, createReq, delReq, updateReq,
  }
}